// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetQuestionsRequest,
  TGetQuestionsModel,
  IMappers,
  TGetQuestionsResponse,
  IGetQuestionsResponse,
  IGetQuestionsResponseError,
} from './types';

export const defaultConfig: TGetQuestionsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-reviews',
  pathApi: '/v1/get-questions/',
  requestType: 'json',
} as TGetQuestionsModel;

export function createGetQuestionsModel(parameters: IGetQuestionsRequest): TGetQuestionsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetQuestionsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetQuestionsRequest;
}

export async function fetchGetQuestions<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetQuestionsOptions<TResponse200, TResponse400>): Promise<TGetQuestionsResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetQuestionsModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetQuestionsResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetQuestionsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetQuestionsResponse;
}
